<!--
 * @Author: 黄昱森
 * @LastEditors: Yu Weifeng weifeng.yu@gientech.com
 * @Description:
-->
<script>
import ChartBase from '../base.vue';
import * as echarts from 'echarts/core';
import { TitleComponent, DatasetComponent, LegendComponent } from 'echarts/components';
import { RadarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { isEmpty, isObject } from 'lodash';
echarts.use([TitleComponent, DatasetComponent, LegendComponent, RadarChart, CanvasRenderer]);

export default {
  name: 'LcRadar',
  mixins: [ChartBase],
  props: {},
  data() {
    return {
      chartClass: ['lc-chart__radar'],
      indicators: []
    };
  },
  mounted() {},
  methods: {
    getCurrentEcharts() {
      return echarts;
    },
    processChartData(data) {
      const options = this.mapOptions;
      let transformData = [];
      // 设置了映射字段 或者 数据里有name和value字段
      if (!isEmpty(options) || (isObject(data[0]) && data[0]['name'] && data[0]['value'])) {
        let indicatorsName = [];
        if ((options && options.type) || data[0]['type']) {
          const groupData = {};
          const indicators = {};
          data.forEach(item => {
            //分组
            const groupType = item[options?.type || 'type'];
            groupData[groupType] = groupData[groupType] ?? [];
            groupData[groupType].push(item);
            // 指标
            const indicatorType = item[options?.dimension || 'name'];
            indicators[indicatorType] = indicators[indicatorType] ?? [];
            indicators[indicatorType].push(item);
          });
          // 获取指标数据
          indicatorsName = Object.keys(indicators);

          const groupKeys = Object.keys(groupData);
          groupKeys.forEach(group => {
            let indicatorsArray = new Array(indicatorsName.length).fill(0);
            groupData[group].forEach(item => {
              indicatorsArray[indicatorsName.indexOf(item[options?.dimension || 'name'])] =
                item[options?.valueMap || 'value'];
            });
            transformData.push({
              name: group,
              value: indicatorsArray
            });
          });
        } else {
          let tempValues = [];
          data.forEach(item => {
            indicatorsName.push(item[options?.dimension || 'name']);
            tempValues.push(item[options?.valueMap || 'value']);
          });
          transformData.push({
            name: '',
            value: tempValues
          });
        }
        this.indicators = indicatorsName.map(item => ({ name: item }));
      } else {
        transformData = data;
      }
      this.chartData = transformData;
    },
    processOptions(options) {
      if (Array.isArray(options['series'])) {
        options['series'][0]['data'] = this.chartData;
      } else {
        options['series']['data'] = this.chartData;
      }
      options['radar']['indicator'] = this.indicators;
      this.chartOptions = options;
    }
  }
};
</script>
